module.exports = __webpack_public_path__ + "static/media/zealer.697da073.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/zealer.png
// module id = 221
// module chunks = 0